// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class RtaAvailabilityService {
   $filter: any
   availableStatusMap: any
   availableStatusMapMsgs: any
   config: any
   isSierraClient: any
   localizeDate: any
   provider: any
   requestableStatusMap: any
   notRequestableTypeMap: Array<string>
   translationService: any
   denyRequestIfNoDueDate: boolean
   availableStatusCode: string = "-"
   
   constructor(translationService: any, config: any, $filter: any) {
      this.getAvailabilityStatus = this.getAvailabilityStatus.bind(this)
      this.getAvailableStatusMap = this.getAvailableStatusMap.bind(this)
      this.getRequestableStatusMap = this.getRequestableStatusMap.bind(this)
      this.unionStatusMap = this.unionStatusMap.bind(this)
      this.formatProperty = this.formatProperty.bind(this)
      this.statusSort = this.statusSort.bind(this)
      this.hasVolume = this.hasVolume.bind(this)
      this.hasYear = this.hasYear.bind(this)
      this.hasCallNumber = this.hasCallNumber.bind(this)
      this.hasLocation = this.hasLocation.bind(this)
      this.getVolumes = this.getVolumes.bind(this)
      this.getStatusMessage = this.getStatusMessage.bind(this)
      this.getTranslatedDisplayString = this.getTranslatedDisplayString.bind(this)
      this.isRequestableForAvailabilities = this.isRequestableForAvailabilities.bind(this)
      this.isRequestable = this.isRequestable.bind(this)
      this.getStatusForAvailabilities = this.getStatusForAvailabilities.bind(this)
      this.getStatusForAvailability = this.getStatusForAvailability.bind(this)
      this.prepareRtaDoc = this.prepareRtaDoc.bind(this)
      this.translationService = translationService
      this.$filter = $filter
      this.config = config
      this.availableStatusMap = this.getAvailableStatusMap()
      this.availableStatusMapMsgs = _.map(config.data.rtaAvailability.rtaAvailableStatusMap, (p: any) => p.name.toLowerCase())
      this.requestableStatusMap = this.getRequestableStatusMap()
      this.notRequestableTypeMap = config.data.rtaAvailability.rtaNotRequestableTypeMap
      this.denyRequestIfNoDueDate = this.config.data.rtaAvailability.denyRequestIfNoDueDate
      this.isSierraClient = config.data.rtaAvailability.isSierraClient
      this.provider = 'cas'

      // filter functions
      this.localizeDate = this.$filter("summonISODate")
   }

   sanitizeAvailabilities(avDocs: any, isSierra = false) {
      const localizeDate = (date: any) => {
         if (date) {
            const localized = this.localizeDate(date.trim())
            if (localized && (localized.toString() !== "Invalid Date")) {
               return localized
            } else {
               return date
            }
         } else {
            return date
         }
      }

      const formatDueDateIfNeeded = function (doc: any) {
         if (!isSierra) {
            return
         }

         //this check was made to skip formatting if the date is already formatted,
         //this line of code is triggerred
         if (doc == null || doc.displayString.length === 0)
            return
         if (doc.displayString.indexOf("Due") > -1) {
            const displayedDate = doc.displayString.split(',')[0].split(" ")[1]
            if (displayedDate.indexOf("-") == -1)
               return doc.displayString
         }

         if (doc.statusMessage.indexOf("Due") > -1) {
            doc.statusMessage = "Due " + localizeDate(doc.statusMessage.substr(4))
         }
         if (doc.displayString.indexOf("Due") > -1) {
            const splitDisplayString = doc.displayString.split(',')
            return doc.displayString = "Due " + localizeDate(splitDisplayString[0].substr(4)) + ", " + splitDisplayString.splice(1).join()
         }
      }

      const sanitizeAvailability = function(doc: any) {
         if (doc.status == null) { doc.status = "unknown" }
         if (doc.statusMessage == null) { doc.statusMessage = "" }
         if (doc.location == null) { doc.location = "" }
         if (doc.callNumber == null) { doc.callNumber = "" }
         if (doc.displayString == null) { doc.displayString = doc.statusMessage }
         if (doc.holdCount && (doc.holdCount !== "0")) {
            const splitDisplayString = doc.displayString.split(',')
            doc.statusMessage = doc.holdCount + " Holds"
            doc.status = 'unknown'
            doc.statusCode = ''
            doc.displayString = doc.statusMessage + ", " + splitDisplayString.splice(1).join()
         }
         return doc
      }

      if (this.isGrouped(avDocs)) {
         return _.forEach(avDocs,(doc: any) => formatDueDateIfNeeded(sanitizeAvailability(doc)))
      } else {
         return formatDueDateIfNeeded(sanitizeAvailability(avDocs))
      }
   }

   getAvailabilityStatus(availability: any) {
      if (this.isGrouped(availability)) {
         return this.getStatusForAvailability(availability[0])
      }

      return this.getStatusForAvailability(availability)
   }

   // retrieve available status map by merging both fields set (if set) in customizer: 'available status map' and 'custom available codes'
   getAvailableStatusMap() {
      return this.unionStatusMap(this.config.data.rtaAvailability.rtaAvailableStatusMap, this.config.data.rtaAvailability.customAvailableCodes)
   }

   // retrieve requestable status map by merging both fields set (if set) in customizer: 'requestable status map' and 'custom requestable codes'
   getRequestableStatusMap() {
      return this.unionStatusMap(this.config.data.rtaAvailability.rtaRequestableStatusMap, this.config.data.rtaAvailability.customRequestableCodes)
   }

   unionStatusMap(rtaStatusMap: any, customCodes: any) {
      const statusMap = _.map(rtaStatusMap, (p: any) => p.code)
      const customMap = customCodes ? customCodes.split(",") : undefined
      if (statusMap?.length && customMap?.length) {
         return _.union(statusMap, customMap)
      }
      return statusMap
   }

   hasProperty(availability: any, property: any) {
      if (availability != null) { return !!availability[property]?.length } else { return false }
   }

   formatProperty(availability: any, property: any) {
      if (this.hasProperty(availability, property)) {
         return availability[property]
      } else if (this.isGrouped(availability) && this.hasProperty(availability[0], property)) {
         return availability[0][property]
      } else { return '-' }
   }

   statusSort(avDoc: any) {
      const statusObject = this.getAvailabilityStatus(avDoc)
      if (statusObject.code === 'available') {
         return 1
      }
      if (statusObject.code === 'not available') {
         return 2
      }
      if (statusObject.code === 'unknown') {
         return 3
      }
   }

   // TODO:: Design availability groups to always be an array (even an array of 1) to avoid asking this all the time
   // Maybe this is already the case and the "isGrouped" question is not necessary?? We should check...
   isGrouped(availability: any) {
      return Array.isArray(availability)
   }

   hasVolume(availabilities: any) {
      return _.some(availabilities, (p: any) => this.hasProperty(p, "volume"))
   }

   hasYear(availabilities: any) {
      return _.some(availabilities, (p: any) => this.hasProperty(p, "year"))
   }

   hasCallNumber(availabilities: any) {
      return _.some(availabilities, (p: any) => this.hasProperty(p, "callNumber"))
   }

   hasLocation(availabilities: any) {
      return _.some(availabilities, (p: any) => this.hasProperty(p, "location"))
   }

   getVolumes(availabilities: any) {
      return _.filter(availabilities, (item: any) => this.hasProperty(item, 'volume'))
   }

   getStatusMessage(availability: any) {
      const translateMessage = (item: any): string => {
         const rawMsg = item.statusMessage ?? ''
         //if there's a customizer entry for the raw ILS term, it returns it
         const translatedMsg = this.translationService.translate(rawMsg)
         if (translatedMsg !== rawMsg) { return translatedMsg }
         //if it is not available from customizer, fallback to Available/Not Available
         const status= this.getStatusForAvailability(item)
         if (status.code === 'available' || status.code === 'not available') {
            return status.translation
         }
         return rawMsg || status.translation
      }

      if (this.isGrouped(availability)) {
         const message = translateMessage(availability[0])
         if (availability.length > 1) { return `${message} (${availability.length}` }
         return `${message}`
      }

      return translateMessage(availability)
   }


   getTranslatedDisplayString(availability: any): string {
      const item = this.isGrouped(availability) ? availability[0] : availability
      if (!item) { return '' }

      const displayString: string = item.displayString || ''

      // Return  Customizer translation for a term when one exists
      const translateIfExists = (token: string): string | null => {
         const translated = this.translationService.translate(token)
         return translated !== token ? translated : null
      }

      // Handle case-insensitive  matching for Customizer keys by generating candidate keys with various common case transformations.
      const translateCaseInsensitiveTerms = (token: string): string | null => {
         if (!token) return null
         const candidates = [
            token,
            token.toLowerCase(),
            token.toUpperCase(),
            token.charAt(0).toUpperCase() + token.slice(1).toLowerCase(),
            token.replace(/\b\w/g, c => c.toUpperCase())
         ]
         for (const key of [...new Set(candidates)]) {
            const translation = translateIfExists(key)
            if (translation !== null) return translation
         }
         return null
      }

      const fullTranslation = translateIfExists(displayString)
      if (fullTranslation !== null) {
         return fullTranslation
      }

    //Attempt first to match the display string to avoid partial matching like "available" from "not available"
      const rawStatus: string = item.statusMessage

      if (rawStatus) {
         const statusPattern = new RegExp(
            rawStatus.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
         const statusMatch = displayString.match(statusPattern)
         if (statusMatch) {
            const matchedText = statusMatch[0]
            const statusTranslation = translateCaseInsensitiveTerms(matchedText)
            if (statusTranslation !== null) {
               return displayString.replace(
                  new RegExp(matchedText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'),
                  statusTranslation
               )
            }
         }
      }

    // Use configuredTerms to detect known RTA values inside displayString.
    // Applies case-insensitive matching and replaces only the matched portion using Customizer-defined translations.
       // Match longer strings first
       const configuredTerms = (this.availableStatusMapMsgs || [])
           .slice()
           .sort((a: any, b: any) => b.length - a.length)
       if (configuredTerms.length) {
         const escapedTerms = configuredTerms.map((t: string) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
         const pattern = new RegExp(escapedTerms.join('|'), 'i')
         const match = displayString.match(pattern)
         if (match) {
            const termTranslation = translateCaseInsensitiveTerms(match[0])
            if (termTranslation !== null) {
               return displayString.replace(match[0], termTranslation)
            }
         }
      }

      return displayString
   }

   isRequestableForAvailabilities(availabilities: any) {
      return _.some(availabilities, (value) => {
         return value
            && (_.contains(this.requestableStatusMap, value.statusCode) || (this.isRequestableWithDueDate(value)))
            && !(value.type != '' && _.contains(this.notRequestableTypeMap, value.type))
      })
   }

   isRequestable(availability: any) {
      return _.some(availability, (value: any) => value &&  _.contains(this.requestableStatusMap, value.statusCode))
   }

   /*
    * An item can be set as requestable even if status code available (-) is set as not requestable if:
    * ** The item has a due date 
    * ** Param 'deny if no due date' from admin console is set to true (inverse logic of: allow if due date present)
    * @param value
    * @returns 
    */
   isRequestableWithDueDate(value: any) {
      return value.statusCode == this.availableStatusCode && this.denyRequestIfNoDueDate == true && value.statusMessage.includes("Due")
   }

   getStatusForAvailabilities(availabilities: any) {
      if (_.every(availabilities, (value: any) => (value === null) || value?.contingencyInfo)) {
         return { code: 'unknown', translation :this.translationService.translations['CHECK_AVAILABILITY'] }
      }
      if (_.every(availabilities, (value: any) => (value.status === 'not available') && !((value.statusMessage != null) ? _.contains(this.availableStatusMapMsgs, value.statusMessage.toLowerCase()) : false))) {
         return { code: 'not available', translation :this.translationService.translations['AVAILABLE_RTA_STATUS_NOT_AVAILABLE'] }
      }
      if (_.some(availabilities, (value: any) => (value.status === 'available') || ((value.statusMessage != null) ? _.contains(this.availableStatusMapMsgs, value.statusMessage.toLowerCase()) : false) || _.contains(this.availableStatusMap, value.statusCode))) {
         return { code: 'available', translation: this.translationService.translations['AVAILABLE_RTA_STATUS_AVAILABLE'] }
      }

      return { code: 'unknown', translation :this.translationService.translations['CHECK_AVAILABILITY'] }
   }

   getStatusForAvailability(availability: any) {
      if (!availability) {
         return { code: 'unknown', translation :this.translationService.translations['CHECK_AVAILABILITY'] }
      }
      if ((availability.status === 'not available') && !((availability.statusMessage != null) ? _.contains(this.availableStatusMapMsgs, availability.statusMessage.toLowerCase()) : false)) {
         return { code: 'not available', translation :this.translationService.translations['AVAILABLE_RTA_STATUS_NOT_AVAILABLE'] }
      }
      if (((availability.statusMessage != null) ? _.contains(this.availableStatusMapMsgs, availability.statusMessage.toLowerCase()) : false) || (availability.status === 'available') || _.contains(this.availableStatusMap, availability.statusCode)) {
         return { code: 'available', translation: this.translationService.translations['AVAILABLE_RTA_STATUS_AVAILABLE'] }
      }

      return { code: 'unknown', translation :this.translationService.translations['CHECK_AVAILABILITY'] }
   }

   prepareRtaDoc(doc: any, isSierraClient: any) {
      // Create "Availability" links to fall back on in abscense of RTA from availability api
      if (!doc.availabilities?.length) {
         const callNumber = doc.callNumDeweyText || doc.callNumDeweyTextOnFail
         doc.availabilities = [{
            location: doc.provider,
            callNumber,
            libraries: doc.libraries,
            statusMessage: doc.displayText,
            displayString: doc.linkInfo,
            status: "unknown",
            type: doc.type,
            contingencyInfo: true
         }]
      }
      // first add the bibId to the availabilities, so it can be used for 'request' functionality for sierrra clients
      // and add link to availabilities, so it can be used to see more availability info
      return _.each(doc.availabilities, (avItem: any) => {
         if (isSierraClient) {
            avItem.bibId = doc.doc.external_document_id
         }
         avItem.libraries = doc.doc.libraries
         avItem.type = avItem.type || doc.type // take type from doc if avItem has no type yet
         if (avItem.type !== 'ai') { return avItem.link = doc.doc.link }
      })
   }
}

RtaAvailabilityService.$inject = ['translationService', 'configService', '$filter']

angular.module('summonApp.services')
   .service('rtaAvailabilityService', RtaAvailabilityService)

